export namespace Enums {
  export enum SignalrType {
    Rmm = "Rmm",
    Chat = "Chat",
  }
  export enum FormEntityEvent {
    OnFilled = "OnFilled",
  }
  export enum SnackbarIcon {
    None,
    InProgress,
    Success,
    Failure,
  }
  /** Subdomain segment in regional gateway URLs (e.g. `gw.usw.*`). */
  export enum ApiGatewayRegionSlug {
    UsWest = "usw",
    Australia = "aue",
  }

  /** B2C id token claim `region` string values; default when missing or unknown is {@link ApiGatewayRegionSlug.UsWest}. */
  export enum ApiGatewayRegionClaim {
    UsWest = "1",
    Australia = "2",
  }

  /** Name of the B2C custom id token claim that selects {@link ApiGatewayRegionSlug}. */
  export enum ApiGatewayIdTokenClaim {
    Region = "region",
  }

  /** Token in `VITE_*` URLs replaced by {@link ApiGatewayRegionSlug} at runtime. */
  export enum ApiGatewayRegionUrlPlaceholder {
    Region = "{region}",
  }
  export enum ClientStatus {
    Active = 1,
    Inactive = 2,
    CreditHold = 3,
  }
  export enum ContactStatus {
    Active = 1,
    Inactive = 2,
  }
  export enum LocationType {
    Location1 = 1,
    Location2 = 2,
    Location3 = 3,
  }
  export enum MenuModule {
    Admin = 1,
    Ticket = 2,
    CRM = 3,
    Asset = 4,
    Application = 7,
    Alert = 17,
    Calendar = 10,
    Integration = 12,
    Report = 20,
    Billing = 23,
    Document = 34,
    Form = 36,
  }
  export enum TicketStatus {
    New = 1,
    Open = 2,
    Solved = 3,
    Closed = 4,
    Merged = 5,
    OnHold = 6,
    Cancelled = 7,
  }
  export enum TicketPriority {
    High = 1,
    Normal = 2,
    Low = 3,
    Urgent = 4,
    No = 5,
  }
  export enum TicketMergeSettings {
    Contacts = 0,
    Comments = 1,
    TimeEntries = 2,
    Products = 3,
    Assignees = 4,
    Assets = 5,
    Tags = 6,
    Groups = 7,
  }
  export enum StateEntitySync {
    InsertOrUpdate = 1,
    Delete = 2,
    CheckStatusUpdate = 3,
    Reload = 4,
  }
  export enum CalendarEntitySync {
    Event = 1,
    Holiday = 2,
    TechnicianHoliday = 3,
    Ticket = 4,
    Outlook = 5,
  }
  export enum NotificationEvents {
    TicketCreated = 1,
    TicketAssigned = 2,
    PingAlert = 3,
    ReportDownload = 4,
    InvoiceDownload = 5,
    TechnicianMention = 6,
    BlockHoursNotification = 7,
    TicketOutage = 8,
    PublicCommentPosted = 9,
    TicketCommentReaction = 10,
    TodoItemAssigned = 11,
    TicketShipmentUpdated = 12,
    CalendarEventConfirmed = 13,
    CalendarEventReminder = 14,
    TicketMerge = 15,
    TodoItemCompleted = 16,
    TicketForm = 17,
  }
  export enum EmailConfigurationStatus {
    Default = 1,
    DefaultEmailRouteCreated = 2,
    CustomDomainCreated = 3,
    CustomDomainVerified = 4,
    CustomEmailRouteCreated = 5,
  }
  export enum AzureBlobType {
    Asset,
    I,
    R,
    Ticket,
    TT,
    Script,
  }
  export enum TicketLastAction {
    New = 1,
    CommentCreated = 2,
    StatusUpdated = 3,
    TechnicianMentioned = 4,
    ExternalCommentCreated = 5,
    TechnicianUpdated = 6,
    Read = 7,
    Unread = 8,
  }
  export enum ApplicationEvent {
    TechnicianGroupUpdated = 2,
    ClientMembershipUpdated = 3,
    ClientAdded = 4,
  }
  export enum TechnicianDataRefreshStatus {
    Refreshed = 0,
    AppRefresh = 1,
    TechnicianSubscribedGroupChanged = 2,
    ClientMembershipChanged = 3,
    ClosedTicketSettingUpdated = 4,
  }
  export enum MinimzedItem {
    Ticket = 1,
    Device = 2,
    Asset = 3,
    TicketCreate = 4,
    AssetCreate = 5,
    Invoice = 6,
    Contract = 7,
    Bundle = 8,
    Product = 9,
    Contact = 10,
    ContactCreate = 11,
    Client = 12,
    ClientCreate = 13,
    Document = 14,
    DocumentCreate = 15,
  }
  export enum RecoveredItem {
    Ticket = 1,
    Client = 2,
    Contact = 3,
  }
  export enum TicketPrioritySettingLevel {
    TwoLevelPriority = 1,
    FiveLevelPriority = 2,
  }
  export enum TechnicianStatus {
    InAMeeting = 1,
    AtOffice = 2,
    AtLunch = 3,
    NotAvailable = 4,
    WorkingRemotely = 5,
    AwayFromOffice = 6,
  }
  export enum TicketDetailComponent {
    Title = 1,
    Description = 2,
    RightSideBar = 3,
    Comment = 4,
    Timeline = 5,
    PinnedComment = 6,
  }
  export enum TicketListComponent {
    FilterView = 1,
  }
  export enum TicketTemplateVisibility {
    Public = 1,
    Private = 2,
    Shortcut = 4,
  }
  export enum RuleType {
    Condition = 1,
    Action = 2,
  }
  export enum RuleCondition {
    TicketStatus = 1,
    TicketReadStatus = 2,
    TicketUnassigned = 3,
    TicketTitle = 4,
    TicketAssignee = 5,
    TicketTimeEntry = 6,
  }
  export enum RuleAction {
    UpdateTicketStatus = 1,
    AssignTicketTechnician = 2,
    SendCustomNotification = 3,
  }
  export enum RuleConditionType {
    If = 1,
    And = 2,
    Or = 3,
  }
  export enum DataType {
    String = 1,
    Number = 2,
    Date = 3,
  }
  export enum RuleEngineSkeletonType {
    TicketStatusUpdate = 1,
  }
  export enum RuleClassName {
    TicketStatusUpdate = "TicketStatusUpdate",
  }
  export enum UserViewingRecordType {
    TicketActionPerformed = 1,
  }
  export enum UserViewingSignalRType {
    UserViewed = 1,
    UserTyping = 2,
  }
  export enum ApplicationType {
    MainApp = 1,
    TicketDetailPopout = 2,
  }
  export enum ThumbnailType {
    None = 0,
    TicketInlineImage = 1,
  }
  export enum TicketTechnicianRole {
    Lead = 1,
    Assisting = 2,
    Watcher = 3,
  }
  export enum ContractDetailComponent {
    Timeline = 1,
    DynamicAsset = 2,
  }
  export enum InvoiceStatus {
    Draft = 1,
    Submitted = 2,
    Paid = 3,
    Void = 4,
    Approved = 5,
    Deleted = 6,
  }
  export enum TicketSource {
    Web = 1,
    Email = 2,
    Phone = 3,
    Chat = 4,
    Alert = 5,
  }
  export enum ShipmentNotification {
    OutForDelivery = 1,
    Delivered = 2,
  }
  export enum AssetPolicyStatus {
    Active = 1,
  }
  export enum AssetPolicyLevel {
    ServiceProvider = 1,
    Device = 2,
  }
  export enum AssetPolicyFragment {
    Device = 1,
    Override = 2,
    Deployment = 3,
  }
  export enum TypeOfAsset {
    Server = 1,
    Workstation = 2,
  }
  export enum AssetPolicyOs {
    Windows = 1,
    Mac = 2,
    Linux = 3,
  }
  export enum PolicyUiActions {
    SelectPolicy = 1,
    Distribute = 2,
  }
  export enum TicketEntityAction {
    Add = 1,
    Update = 2,
    Delete = 3,
    Sort = 4,
  }
  export enum AssetEntityAction {
    Add = 1,
    Update = 2,
    Delete = 3,
  }
  export enum DeviceEntityAction {
    Add = 1,
    Update = 2,
    Delete = 3,
  }
  export enum TicketDetailCommentTab {
    Public = -1,
    Private = -2,
  }
  export enum TicketDetailTimelineTab {
    Everything = -1,
    Public = -2,
    Private = -3,
    Time = -4,
    Product = -5,
    Checklist = -6,
    ShipmentTracking = -7,
  }
  export enum DashboardWidgets {
    TechnicianWorkload = 1,
    TicketKillRate = 2,
  }
  export function GetDictionary(definition: any) {
    return Object.keys(definition)
      .filter((k) => typeof definition[k as any] === "number")
      .map((key) => ({ value: definition[key], text: key }));
  }
  export enum ApiMethods {
    Get = 1,
    Post = 2,
    Patch = 3,
    PostDataToGetPDF = 4,
    PostDataToGetFile = 5,
    Delete = 6,
  }
  export enum AssetListWorkerCases {
    Default = 1,
  }
  export enum AssetCheckEvent {
    EventLog = 6008,
  }

  export enum TicketMacroActions {
    Title = 1,
    PrivateComment = 2,
    Status = 3,
    LeadAssignee = 4,
    Contact = 5,
    Tag = 6,
    Priority = 7,
    Group = 8,
    Assets = 9,
    Product = 10,
    PublicComment = 11,
    AssistingAssignees = 12,
    Watchers = 13,
    TodoList = 14,
    WaitBlock = 15,
  }
  export enum TicketMacroVisibility {
    Public = 1,
    Private = 2,
    TechniciansInGroups = 3,
  }
  export enum TicketMacroPlaceholder {
    TicketLeadAssigneeFullName = 1,
    LoggedInUserFullName = 2,
    TicketStatus = 3,
    TicketTitle = 4,
    TicketAssistingAssigneesFullNames = 5,
    TicketWatchersFullNames = 6,
    TicketCreatedOn = 7,
    TicketGroupNames = 8,
    TicketId = 9,
    TicketURL = 10,
    TicketClientFullName = 11,
    TicketPriority = 12,
    TicketUpdatedOn = 13,
    TicketLeadAssigneeFirstName = 14,
    TicketAssistingAssigneesFirstNames = 15,
    TicketWatchersFirstNames = 16,
    LoggedInUserFirstName = 17,
    TicketCreatedByFullName = 18,
    TicketCreatedByFirstName = 19,
    TicketPrimaryContactFullName = 20,
    TicketPrimaryContactFirstName = 21,
  }
  export enum TicketMacroWaitBlockDelay {
    Hour = "Hour",
    Day = "Day",
    ProvidedOnTrigger = "Provide_On_Trigger",
    Minute = "Minute",
  }

  export enum BaseRole {
    User = 1,
    Billing = 2,
    Asset = 3,
    Alert = 4,
    Settings = 5,
    BillingReadOnly = 6,
    TicketReadOnly = 7,
    Calendar = 9,
    Crm = 10,
    Ticket = 11,
    AssetReadOnly = 12,
    Document = 13,
    Form = 14,
  }

  export enum SignalrEvent {
    InsertOrUpdate = 1,
    Delete = 2,
  }

  export enum AssetFilterType {
    Contract = 1,
    OverridePolicy = 2,
  }
  export enum CheckType {
    ErrorLog = 1,
    DiskUsage = 2,
    Connectivity = 3,
    Process = 4,
    Service = 5,
    Antivirus = 6,
  }
  export enum AntivirusChecks {
    isDisabled = 1,
    isOutOfDate = 2,
  }
  export enum AssetList {
    status = 1,
    customAssetName = 2,
    assetTypeName = 3,
    assetStatusName = 4,
    internalServiceTag = 5,
    clientName = 6,
    clientLocationName = 7,
    lastLoggedOnUser = 8,
    localIPAddress = 10,
    publicIPAddress = 11,
    osName = 13,
    osType = 14,
    osVersion = 15,
    osLastBootUpTime = 16,
    lastDisconnectDateTime = 17,
    Alerts = 19,
    shellVersion = 20,
    rmmVersion = 21,
    installerVersion = 22,
    Actions = 23,
    Description = 24,
  }
  export enum EventLevel {
    Critical = 1,
    Error = 2,
    Warning = 3,
    Informational = 4,
    Verbose = 5,
  }
  export enum ClientCreate {
    ClientInfo = 1,
    Location = 2,
    Contact = 3,
    WebDomain = 4,
  }
  export enum ServiceProviderType {
    Msp = 1,
    Enterprise = 2,
  }

  export enum ScriptType {
    Powershell = 1,
    CommandLine = 2,
  }
  export enum LoadDataOnDemand {
    TicketList = 1,
    TicketDetail = 2,
    AllData = 3,
  }
  export enum TipTapBubbleMenuOptions {
    Bold = 1,
    Italic = 2,
    HeadingLevelOne = 3,
    HeadingLevelTwo = 4,
    HeadingLevelThree = 5,
    BlockQuote = 6,
    OrderedList = 7,
    BulletList = 8,
    Code = 9,
  }
  export enum IDbEntityStore {
    Ticket = 1,
    Asset = 2,
    Device = 3,
    Contact = 4,
    Alert = 5,
    Script = 6,
    Technician = 7,
    TechnicianGroup = 8,
  }
  export enum EntityUpdateMode {
    Api = 0,
    Local = 1,
  }
  export enum SignalRMessageType {
    TicketPrivateCommentAdded,
    TicketGroupSync,
    TicketAssignedNotification,
    PublicCommentCreatedOnAssignedTicket,
    TicketShipmentUpdated,
    TicketCommentReaction,
    TodoItemCompleted,
    CalendarEventReminder,
    CalendarEventConfirmed,
    TicketTechnicainCommentInMention,
    TodoTechnicianAssigned,
    TicketMergedNotification,
    TicketCreatedNotification,
    TicketEntityTickSync,
    TicketTechnicianEntitySync,
    TechnicianCurrentStatusSync,
    InactiveTechnicianCalendarEntitySync,
    TechnicianPinnedMenuSync,
    TicketEntitySync,
    TimeSpentFilterEntitySync,
    InvoiceEntitySync,
    InvoiceFilterEntitySync,
    CalendarEntitySync,
    TicketMacroEntitySync,
    TicketAssetEntitySync,
    TicketEntityCollectionSync,
    TicketTagEntitySync,
    TicketTrackingEntitySync,
    TagEntitySync,
    TicketFilterViewEntitySync,
    TodoItemEntitySync,
    TodoListEntitySync,
    ReviewInvoiceFilterEntitySync,
    ProductFilterEntitySync,
    ProductEntitySync,
    BundleFilterEntitySync,
    ContractEntitySync,
    ContractFilterEntitySync,
    BlockHoursNotification,
    InvoiceDownload,
    ClientFilterViewEntitySync,
    InactiveContactCalendarEntitySync,
    ClientEntityTickSync,
    ContactEntitySync,
    ContactEntityTickSync,
    ContactInactiveEntitySync,
    ClientEntitySync,
    ClientLocationEntitySync,
    ClientLocationUpdateEntitySync,
    ClientLocationEntityTickSync,
    ContactFilterEntitySync,
    EmailConfigurationEntitySync,
    CheckStatusEntitySync,
    ScriptEntitySync,
    PingNotification,
    ItemRecovered,
    DeviceAlertNotification,
    AssetListHeaderEntitySync,
    AssetFilterViewEntitySync,
    AlertFilterViewEntitySync,
    AcknowledgedTicket,
    ReportDownload,
    AssetEntitySync,
    DeviceEntityTickSync,
    DeviceEntitySync,
    ProductEntityTickSync,
    TicketTechnicianEntitySyncService,
    UpdateTechnicianGroupEntityByTick,
    TechnicianLocationSyncService,
    TicketTechnicianGroupEntitySync,
    TechnicianSettingsSync,
    TicketCreated,
    FillServiceLocationHolidayById,
    FillCalendarItemContact,
    DeletedTicketEntity,
    InactiveClientEntity,
    InactiveContactEntity,
    DeleteFromTechnicianEntity,
    DeleteFromTechnicianGroupEntity,
    DeleteFromTechnicianCurrentStatusEntity,
    DeleteFromNotificationListEntity,
    TicketFormEntitySync,
    OutlookCalendarEventSync,
    OutLookCalendarEntitySyncAll,
    OutLookDeleteCalendarEntitySync,
    FillMSPTicketSettings,
    ClientSubscribedGroupEntity,
    ContactTagSync,
    TicketApprovalEntitySync,
    FormEntitySync,
  }
  export enum EmailLogType {
    Inbound = 1,
    Outbound = 2,
  }
  export enum ApplicationStoreManagerModules {
    Ticket,
    Client,
    Contact,
    Asset,
    Requisition,
    Billing,
    PurchaseOrder,
  }
  export enum EntitySyncManager {
    GetMenuList,
    GetTechnicianPinnedMenuList,
    FillTechnicianRole,
    FillTicketFilterView,
    FillTicketTracking,
    GetTodoList,
    FillClients,
    FillDevices,
    FillAsset,
    FillCalendarItem,
    FillBlockHours,
    FillTickets,
    GetEmailConfigurations,
    FillTags,
    FillAllTicketTags,
    FillAssetTypes,
    FillAssetOs,
    FillAssetFieldDataType,
    FillTimeZone,
    FillServiceProiderWorkingDays,
    GetAssetFilterViews,
    GetInvoices,
    GetProducts,
    GetContracts,
    GetTicketMacros,
    GetListHeaders,
    FillClientlocations,
    CheckTicketFilterViewTick,
    FillTechnicians,
    GetContactsOfOtherGroups,
    FillContacts,
    FillTechnicianGroup,
    FillClientMembershipGroups,
    GetTechnicianStatusList,
    GetTechnicianCurrentStatusList,
    FillClosedTickets,
    FillCustomStatus,
    FillScripts,
    FillAntivirusList,
    GetTodoItemListByTicketId,
    FillTicketTrackingByTicketId,
    UpdateUnreadEmailNotificationIcon,
    FillCalendarItemServiceLocation,
    FillCalendarItemContact,
    FillServiceLocationHolidayById,
    GetTechnicianByTick,
    GetTechnicianGroupByTick,
    CheckTechnicianGroupTick,
    CheckScriptTick,
    CheckClientTick,
    CheckInvoiceTick,
    CheckProductTick,
    CheckContractTick,
    CheckDeviceTick,
    CheckTicketTick,
    CheckAlertTick,
    CheckContactTick,
    CheckTodoListTick,
    FillMSPTicketSettings,
    FillServiceProiderLocations,
    ClientSubscribedGroupEntity,
    FillContactTags,
    FillProjectTags,
    FillProjectTypes,
  }
  export enum SyncManagerMode {
    ClearAndFill,
    Fill,
  }
  export enum PageName {
    TicketList,
    TicketDetail,
    NoPageFound,
  }

  export enum SearchType {
    Relevant = 1,
    ExactMatch = 2,
  }
  export enum TicketSearchType {
    Title = 1,
    Comment = 2,
  }
  export enum FormElementType {
    ShortAnswer = "Short_Answer",
    LongAnswer = "Long_Answer",
    MultipleChoice = "Multiple_Choice",
    Checkbox = "Checkbox",
    Number = "Number",
    Email = "Email",
    PhoneNumber = "Phone_Number",
    Link = "Link",
    Date = "Date",
    Time = "Time",
    Dropdown = "Dropdown",
    Heading1 = "Heading_1",
    Heading2 = "Heading_2",
    Heading3 = "Heading_3",
    Label = "Label",
    Text = "Text",
    Divider = "Divider",
    SubmitButton = "Submit_Button",
    FormSubmissionMessage = "Form_Submission_Message",
    Toggle = "Toggle",
    Question = "Question",
    QuestionAndShortAnswer = "Question_Short_Answer",
    QuestionAndLongAnswer = "Question_Long_Answer",
    QuestionAndCheckbox = "Question_Checkbox",
    QuestionAndNumber = "Question_Number",
    QuestionAndEmail = "Question_Email",
    QuestionAndLink = "Question_Link",
    QuestionAndDate = "Question_Date",
    QuestionAndTime = "Question_Time",
    QuestionAndDropdown = "Question_Dropdown",
    QuestionAndMultipleChoice = "Question_MultipleChoice",
    QuestionAndPhoneNumber = "Question_PhoneNumber",
    QuestionAndToggle = "Question_Toggle",
    ConditionalLogic = "Conditional_Logic",
  }
  export enum WhenLogicOperator {
    Equal = "eq",
    NotEqual = "ne",
  }
  export enum BooleanOperator {
    AND = "and",
    OR = "or",
  }
  export enum ConditionalLogicAction {
    ShowBlocks = "Show_Blocks",
    HideBlocks = "Hide_Blocks",
    RequireAnswer = "Require_Answer",
  }
  export enum PolicyItem {
    Plugin = "Plugins",
    Check = "Checks",
    Script = "Scripts",
  }
  export enum DeviceTagProperty {
    Apps = 1,
    Services = 2,
    Client = 3,
    ClientLocation = 4,
    TypeOfDevice = 5,
    ServiceProvider = 6,
  }
  export enum AssetDefaultTagType {
    Basic = 0,
    ServiceProvider = 1,
    Client = 2,
    ClientLocation = 3,
    TypeOfDevice = 4,
  }
  export enum AssetTagCondition {
    Contains = 1,
    Equals = 2,
  }

  export enum DeviceTagMappingType {
    Basic = 1,
    Default = 2,
    DeviceLevel = 3,
  }

  export enum OutlookCalendarType {
    Daily = 0,
    Weekly = 1,
    Monthly = 2,
    Custom = 3,
    Yearly = 4,
  }

  export enum OutlookDays {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
  }

  export enum AntivirusStatus {
    Unknown = 0,
    Missing = 1,
    UptoDate = 2,
    OutOfDate = 3,
  }

  export enum AppManagementStatus {
    Unknown = 0,
    Missing = 1,
    UpdatesAvailable = 2,
    UpToDate = 3,
    Uninstalled = 4,
    Installed = 5,
    OutOfThreshold = 6,
    AppsOperationInProgress = 7,
  }

  export enum WindowsUpdateStatus {
    Unknown = 0,
    UpToDate = 1,
    RestartRequired = 2,
    UpdatesAvailable = 4,
  }

  export enum DeviceRebootRequiredReason {
    Unknown = 0,
    WindowsUpdate = 1,
    OptionalFeatureORUpdateDriver = 2,
    WindowsDomainJoin = 4,
    WindowsFileRename = 8,
    ComputerRename = 16,
  }

  export enum ProjectStatus {
    NotStarted = 1,
    InProgress = 2,
    OnHold = 3,
    Completed = 4,
    Closed = 5,
  }

  export enum ProjectPriority {
    NoPriority = 4,
    Urgent = 1,
    High = 3,
    Normal = 0,
    Low = 2,
  }
  export enum ProjectEvent {
    ProjectCreated,
    ProjectSectionCreated,
    ProjectSectionUpdated,
    ProjectSectionDeleted,
    ProjectLeadAssigneeUpdated,
    ProjectContactsUpdated,
    ProjectDueDateUpdated,
    ProjectTypeUpdated,
    ProjectTagsUpdated,
    ProjectGroupsUpdated,
    ProjectStatusUpdated,
    ProjectCommentAdded,
    ProjectDeleted,
    ProjectRecovered,
    ProjectTitleUpdated,
    ProjectWatchersUpdated,
    ProjectClientUpdated,
    ProjectClientLocationUpdated,
    ProjectDescriptionUpdated,
    TaskCreated,
    TaskSectionUpdated,
    TaskLeadAssigneeUpdated,
    TaskAssistingAssigneesUpdated,
    TaskAssetsUpdated,
    TaskPriorityUpdated,
    TaskDueDateUpdated,
    TaskBlockersUpdated,
    TaskReadStatusUpdated,
    TaskTPCAdded,
    TaskShipmentTrackingAdded,
    TaskChecklistAdded,
    TaskChecklistDeleted,
    TaskApprovalAdded,
    TaskCommentAdded,
    TaskStatusUpdated,
    TaskDeleted,
    TaskRecovered,
    TaskChecklistItemAdded,
    TaskChecklistItemDeleted,
    TaskChecklistItemCompleted,
    TaskBannerUpdated,
    TaskTitleUpdated,
    TaskWatchersUpdated,
  }

  export enum TaskStatus {
    NotStarted = 1,
    WorkingOnIt = 2,
    OnHold = 3,
    Done = 4,
  }

  export enum BusinessHourType {
    Custom = 1,
    AlwaysOpen = 2,
  }

  export enum ReportsQuickFilters {
    ThisMonth = 0,
    LastMonth = 1,
    ThisQuarter = 2,
    LastQuarter = 3,
    YearToDate = 4,
    Today = 5,
    Yesterday = 6,
    Past7Days = 7,
    Past30Days = 8,
    Past90Days = 9,
    Past365Days = 10,
    ThisWeek = 11,
    ThisYear = 12,
    PreviousWeek = 13,
    PreviousYear = 14,
  }

  /** CX sign-in page background style (GetMspCXSetting / cx app settings). */
  export enum SignInBackgroundType {
    Gradient = 1,
    Solid = 2,
  }

  /** CX sign-in page theme preference (GetMspCXSetting / cx app settings). */
  export enum SignInBackgroundTheme {
    Dark = 1,
    Light = 2,
    System = 3,
  }
}
